<template>
  <div
    class="game-cotrol-panel-button"
    :class="[{ 'disable-check': blockCheckAction || blockResetAction || blockCheck }]"
    @click="dispatchEvent()"
  >
    <div
      class="check-game transition-container"
      :class="[{ 'icon-margin': !multiStage }, { 'icon-margin-small': multiStage }]"
      v-if="name === 'checkButton' && !blockCheck"
    >
      <div
        class="control-panel-button-image check-game-disabled"
        v-if="disabled || blockCheckAction || blockCheck"
      ></div>
      <div
        class="control-panel-button-image check-game-active active"
        v-if="!disabled && !blockCheckAction && !blockCheck"
      ></div>
      <div
        class="control-panel-button-image check-game-inactive inactive"
        v-if="!disabled && !blockCheckAction && !blockCheck"
      ></div>
    </div>
    <div
      class="resolve-button transition-container"
      :class="[{ 'icon-margin': !multiStage }, { 'icon-margin-small': multiStage }]"
      v-if="name === 'resolveButton'"
    >
      <div class="control-panel-button-image resolve-button-disabled" v-if="disabled || blockCheckAction"></div>
      <div class="control-panel-button-image resolve-button-active active" v-if="!disabled && !blockCheckAction"></div>
      <div
        class="control-panel-button-image resolve-button-inactive inactive"
        v-if="!disabled && !blockCheckAction"
      ></div>
    </div>
    <div class="next-button transition-container icon-margin-small" v-if="name === 'nextButton' && multiStage">
      <div class="control-panel-button-image next-button-disabled" v-if="disabled || multiStage"></div>
      <div class="control-panel-button-image next-button-active active" v-if="!disabled && multiStage"></div>
      <div class="control-panel-button-image next-button-inactive inactive" v-if="!disabled && multiStage"></div>
    </div>
    <div
      class="reset-button transition-container"
      :class="[{ 'icon-margin': !multiStage }, { 'icon-margin-small': multiStage }]"
      v-if="name === 'resetButton'"
    >
      <div class="control-panel-button-image reset-button-disabled" v-if="disabled || blockResetAction"></div>
      <div class="control-panel-button-image reset-button-active active" v-if="!disabled && !blockResetAction"></div>
      <div
        class="control-panel-button-image reset-button-inactive inactive"
        v-if="!disabled && !blockResetAction"
      ></div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
export default {
  name: 'tr-game-control-panel-button',
  props: {
    name: {
      type: null,
      default: '',
    },
    disabled: {
      type: null,
      default: false,
    },
  },
  mounted: function () {},
  methods: {
    throttled: _.throttle((context) => {
      context.$emit('eventType');
    }, 1100),
    dispatchEvent() {
      if (
        this.name === 'checkButton' ||
        this.name === 'resetButton' ||
        !this.$store.getters.multiStageTest ||
        (this.$store.getters.multiStageTest && this.$store.getters.nextButtonStatus)
      ) {
        this.throttled(this);
      }
    },
    // dispatchEvent() {
    //   console.log('this', this);
    // }
  },
  computed: {
    blockCheckAction() {
      return this.$store.getters.blockCheckAction && this.name === 'checkButton';
    },
    blockCheck() {
      return this.$store.getters.blockCheck && this.name === 'checkButton';
    },
    blockResetAction() {
      return this.$store.getters.blockResetAction && this.name === 'resetButton';
    },
    multiStage() {
      return this.$store.getters.multiStageTest;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/sass/iconColor';

.game-cotrol-panel-button {
  display: flex;
  text-align: center;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 30px;
  color: $firstIconColor;
  .transition-container {
    position: relative;
    width: 64px;
    height: 64px;
  }
  .transition-container-small {
    position: relative;
    width: 54px;
    height: 54px;
  }
  .control-panel-button-image {
    position: absolute;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
  .icon-margin {
    margin: 0px 8px;
  }
  .icon-margin-small {
    margin: 0px 2px;
  }
  .next-button-active {
    background-image: url('~@/assets/icons/book/gameInterface/nextStageInActive.png');
  }
  .next-button-inactive {
    background-image: url('~@/assets/icons/book/gameInterface/nextStageActive.png');
  }
  .next-button-disabled {
    background-image: url('~@/assets/icons/book/gameInterface/nextStage_nieaktywny.png');
  }
  .check-game-active {
    background-image: url('~@/assets/icons/book/gameInterface/checkGameInActive.png');
  }
  .check-game-inactive {
    background-image: url('~@/assets/icons/book/gameInterface/checkGameActive.png');
  }
  .check-game-disabled {
    background-image: url('~@/assets/icons/book/gameInterface/button_SPRAWDZ_nieaktywny.png');
  }
  .resolve-button-active {
    background-image: url('~@/assets/icons/book/gameInterface/showInCorrectActive.png');
  }
  .resolve-button-inactive {
    background-image: url('~@/assets/icons/book/gameInterface/showCorrectActive.png');
  }
  .resolve-button-disabled {
    background-image: url('~@/assets/icons/book/gameInterface/button_KEY_nieaktywny.png');
  }
  .reset-button-active {
    background-image: url('~@/assets/icons/book/gameInterface/resetInActive.png');
  }
  .reset-button-inactive {
    background-image: url('~@/assets/icons/book/gameInterface/resetActive.png');
  }
  .reset-button-disabled {
    background-image: url('~@/assets/icons/book/gameInterface/button_RESET_nieaktywny.png');
  }

  .inactive {
    opacity: 0;
    &:hover {
      transition: opacity 0.3s ease-in-out;
      opacity: 1;
    }
  }
}
.disable-check {
  pointer-events: none;
  opacity: 0.5;
}
</style>
